module.exports = __webpack_public_path__ + "portal/static/img/uob.f363c7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/uob.png
// module id = +Nzm
// module chunks = 67